module.exports = "/_next/static/images/01f82e8b840d8ec296af534700fed468-vigilado-xl.png";